import { PeriodicType } from 'app/shared/model/enumerations/periodicType';

export enum ReportType {
  JOURNEY = 'journey',
  DAILY = 'daily',
  FENCE_ALERTS = 'fence-alerts',
  FENCE_PASSAGES = 'fence-passages',
}

export enum ReportOutputFormat {
  XLSX = 'XLSX',
  PDF = 'PDF',
}

export enum ReportSensorId {
  SPEED_MAX = 'SPEED_MAX',
  ODOMETER_MAX = 'ODOMETER_MAX',
  RUNNING_TIME = 'RUNNING_TIME',
  IDLE_TIME = 'IDLE_TIME',
  MILEAGE_TRAVELED = 'MILEAGE_TRAVELED',
  AVG_FUEL_CONSUMPTION = 'AVG_FUEL_CONSUMPTION',
}

export type PeriodOption = PeriodicType.TODAY | PeriodicType.YESTERDAY | PeriodicType.WEEK | PeriodicType.CUSTOM;

export interface ITelemetrySensorField {
  id: ReportSensorId;
  labelKey: string;
}

export const TELEMETRY_SENSOR_FIELDS: ITelemetrySensorField[] = [
  { id: ReportSensorId.SPEED_MAX, labelKey: 'fleetSenseApp.reports.desiredData.SPEED_MAX' },
  { id: ReportSensorId.ODOMETER_MAX, labelKey: 'fleetSenseApp.reports.desiredData.ODOMETER_MAX' },
  { id: ReportSensorId.RUNNING_TIME, labelKey: 'fleetSenseApp.reports.desiredData.RUNNING_TIME' },
  { id: ReportSensorId.IDLE_TIME, labelKey: 'fleetSenseApp.reports.desiredData.IDLE_TIME' },
  { id: ReportSensorId.MILEAGE_TRAVELED, labelKey: 'fleetSenseApp.reports.desiredData.MILEAGE_TRAVELED' },
  { id: ReportSensorId.AVG_FUEL_CONSUMPTION, labelKey: 'fleetSenseApp.reports.desiredData.AVG_FUEL_CONSUMPTION' },
];

export interface IBatchJourneyReportRequest {
  vehicleIds: number[];
  periodicType?: PeriodicType;
  dateStart?: string;
  dateEnd?: string;
}

export interface IBatchTelemetryReportRequest {
  vehicleIds: number[];
  dateStart: string;
  dateEnd: string;
  sensorIds: string[];
}

export type FenceType = 'CIRCLE' | 'POLYGON';

export interface IFenceSelection {
  id: number;
  type: FenceType;
}

export interface IBatchFenceAlertsReportRequest {
  vehicleIds: number[];
  periodicType?: PeriodicType;
  dateStart?: string;
  dateEnd?: string;
  fences?: IFenceSelection[];
}

export interface IBatchFencePassagesReportRequest {
  companyId?: number;
  vehicleIds: number[];
  dateStart: string;
  dateEnd: string;
  fences: IFenceSelection[];
}
